module.exports = __webpack_public_path__ + "img/couples-054.863d6565.jpg";